<template>
  <div id="paginaImportaTracciatiContabilitaZip">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">

      <!-- Card File Upload:  -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Importazione Tracciati Contabili</b-card-title>
              <b-card-text class="mb-0">
                Teatro Coccia
              </b-card-text>
            </div>
            <!-- dropdown menù laterale dx -->
            <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
              </template>
              <b-dropdown-item href="#">
                ...
              </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <label for="zipfile" class="h5">Seleziona un file .zip contenente PNTESTA.TXT, PNRIGCON.TXT, PNRIGIVA.TXT</label>
                <ejs-uploader ref="zipfile" id='zipfile' name="zipfile" :asyncSettings="path" :removing="addJWTHeaders"
                  :autoUpload="false" :uploading="onFileUpload" :buttons="buttons" :success="afterUpload" ></ejs-uploader>


              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import Vue from 'vue'
import useJwt from '@/auth/jwt/useJwt'
import { CardPlugin, DropdownPlugin,LayoutPlugin } from 'bootstrap-vue'

import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons'
import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs'
import { createElement } from '@syncfusion/ej2-base'

// use bootstrap-vue
Vue.use(CardPlugin)
Vue.use(DropdownPlugin)
Vue.use(LayoutPlugin)
// use Syncfusion
Vue.use(ButtonPlugin)
Vue.use(UploaderPlugin)

export default {
  data() {
    return {
      d: [],
      buttonState: false,
      path: {
        saveUrl: `${process.env.VUE_APP_API_ENDPOINT}/demo/api/pnrigcon/importazip`,
        removeUrl: `${process.env.VUE_APP_API_ENDPOINT}/demo/api/pnrigcon/removezip`,
      },
      buttons: { browse: "Seleziona il File", clear: "Cancella", upload: "Processa" },
    }
  },
  methods: {
    // per toast
    makeToast(variant = null, title = 'titolo', message = 'messaggio') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
      })
    },
    addJWTHeaders(args) {
      const token = useJwt.getToken()

      useJwt.check() // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader('Authorization', 'Bearer ' + token)
    },
    onFileUpload(args) {
      const token = useJwt.getToken()
      this.makeToast('primary', 'Info', 'Import Avviato')
      useJwt.check() // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader('Authorization', 'Bearer ' + token)
    },
    afterUpload(args) {
      // console.log(args)
      if (args.name === 'success') {
        this.makeToast('primary', 'Info', 'Import eseguito correttamente')
      } else {
        // mostrare errori import
        this.makeToast('primary', 'Info', 'Import eseguito non correttamente')
      }
    },
  },
}
</script>
<style>
@import "~@syncfusion/ej2-base/styles/bootstrap.css";
@import "~@syncfusion/ej2-buttons/styles/bootstrap.css";
@import "~@syncfusion/ej2-vue-inputs/styles/bootstrap.css";
.control-section {
  height: 100%;
  min-height: 200px;
}

button:has(> span.prova)
{
  display: none;
}
</style>
